import Navbar from "@/pages/home/components/Navbar";
import Hero, { StatBar } from "@/pages/home/components/Hero";
import TopicWall from "@/pages/home/components/TopicWall";
import RankSection from "@/pages/home/components/RankSection";
import ProfileSection from "@/pages/home/components/ProfileSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import CommentSection from "@/pages/home/components/CommentSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Navbar />
      <main>
        <Hero />
        <StatBar />
        <TopicWall />
        <RankSection />
        <ProfileSection />
        <TimelineSection />
        <CommentSection />
      </main>
      <Footer />
    </div>
  );
}